import { render, staticRenderFns } from "./ReportsLayout.vue?vue&type=template&id=40c303f8&scoped=true&"
import script from "./ReportsLayout.vue?vue&type=script&lang=ts&"
export * from "./ReportsLayout.vue?vue&type=script&lang=ts&"
import style0 from "./ReportsLayout.vue?vue&type=style&index=0&id=40c303f8&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40c303f8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTab } from 'vuetify/lib/components/VTabs';
installComponents(component, {VCol,VContainer,VRow,VSpacer,VTab})
